'use client';

import { styled, SxProps } from '@mui/material/styles';

import NextImage from 'next/image';

import { File } from '@peerless/data-access/strapi';
import { formatMediaUrl, ImageSize } from '../utils';

interface Props {
  src: File;
  alt?: string;
  size?: ImageSize;
  sx?: SxProps;
}

const ImageStyled = styled(NextImage)({});

export const Image: React.FC<Props> = ({ src, alt, size, sx = {} }) => {
  return <ImageStyled sx={sx} src={formatMediaUrl(src, size)} alt={src.alternativeText ?? alt} />;
};
